import type { State } from 'src/shared/core/type/reduxTypes';

const getSegment = (state) => state.app.braindates.joined;

export const getJoinedBraindates = (state: State): number[] =>
  getSegment(state).joined;
